import {
	customerAccessTokenFragment,
	customerUserErrorFragment,
	userErrorFragment,
	customerFragment,
	customerOrdersFragment,
	addressFragment,
	cartFragment,
	cartUserErrorFragment,
	productAvailabilityFragment,
	productBasicFragment,
} from './fragments';

export const customerAccessTokenCreateWithMultipass = `
	mutation customerAccessTokenCreateWithMultipass($multipassToken: String!) {
		customerAccessTokenCreateWithMultipass(multipassToken: $multipassToken) {
			customerAccessToken {
			  ...CustomerAccessTokenFragment
			}
			customerUserErrors {
			  ...CustomerUserErrorFragment
			}
		}
	}

	${customerAccessTokenFragment}
	${customerUserErrorFragment}
`;

export const customerAccessTokenRenew = `
	mutation customerAccessTokenRenew($accessToken: String!) {
		customerAccessTokenRenew(customerAccessToken: $accessToken) {
			customerAccessToken {
			  ...CustomerAccessTokenFragment
			}
			userErrors {
			   ...UserErrorFragment
			}
		}
	}

	${customerAccessTokenFragment}
	${userErrorFragment}
`;

export const customerUpdate = `
	mutation customerUpdate($customerInput: CustomerUpdateInput!, $accessToken: String!) {
		customerUpdate(customer: $customerInput, customerAccessToken: $accessToken) {
			customer {
			   ...CustomerFragment
			  ...CustomerOrdersFragment
			}
			customerAccessToken {
			   ...CustomerAccessTokenFragment
			}
			customerUserErrors {
			   ...CustomerUserErrorFragment
			}
		}
	}

	${customerFragment}
	${customerOrdersFragment}
	${customerAccessTokenFragment}
	${customerUserErrorFragment}
`;

export const customer = `
	query customer($accessToken: String!) {
		customer(customerAccessToken: $accessToken) {
			...CustomerFragment
			...CustomerOrdersFragment
		}
	}

	${customerFragment}
	${customerOrdersFragment}
`;

export const customerOrders = `
	query customer($accessToken: String!) {
		customer(customerAccessToken: $accessToken) {
			...CustomerOrdersFragment
		}
	}

	${customerOrdersFragment}
	${addressFragment}
`;

export const customerAddressCreate = `
	mutation customerAddressCreate($address: MailingAddressInput!, $accessToken: String!) {
		customerAddressCreate(address: $address, customerAccessToken: $accessToken) {
			customerAddress {
				...AddressFragment
			}
			customerUserErrors {
				...CustomerUserErrorFragment
			}
	}
	}

	${addressFragment}
	${customerUserErrorFragment}
`;

export const customerAddressUpdate = `
	mutation customerAddressUpdate($address: MailingAddressInput!, $accessToken: String!, $id: ID!) {
		customerAddressUpdate(address: $address, customerAccessToken: $accessToken, id: $id) {
			customerAddress {
				...AddressFragment
			}
			customerUserErrors {
				...CustomerUserErrorFragment
			}
	}
	}

	${addressFragment}
	${customerUserErrorFragment}
`;

export const customerAddressDelete = `
	mutation customerAddressDelete($accessToken: String!, $id: ID!) {
		customerAddressDelete(customerAccessToken: $accessToken, id: $id) {
			customerUserErrors {
				...CustomerUserErrorFragment
			}
			deletedCustomerAddressId
		}
	}

	${customerUserErrorFragment}
`;

export const customerDefaultAddressUpdate = `
	mutation customerDefaultAddressUpdate($id: ID!, $accessToken: String!) {
		customerDefaultAddressUpdate(addressId: $id, customerAccessToken: $accessToken) {
			customer {
				...CustomerFragment
				...CustomerOrdersFragment
			}
			customerUserErrors {
				...CustomerUserErrorFragment
			}
		}
	}

	${customerFragment}
	${customerOrdersFragment}
	${customerUserErrorFragment}
`;

export const cart = `
	query($id: ID!) {
		cart(id: $id) {
			...CartFragment
		}
	}

	${cartFragment}
`;

export const cartCreate = `
	mutation ($input: CartInput) {
		cartCreate(input: $input) {
			cart {
				...CartFragment
			}
			userErrors {
				...CartUserErrorFragment
			}
		}
	}

	${cartFragment}
	${cartUserErrorFragment}
`;

export const cartLinesAdd = `
	mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
		cartLinesAdd(cartId: $cartId, lines: $lines) {
			cart {
				...CartFragment
			}
			userErrors {
				...CartUserErrorFragment
			}
		}
	}

	${cartFragment}
	${cartUserErrorFragment}
`;

export const cartLinesRemove = `
	mutation cartLinesRemove($cartId: ID!, $lineIds: [ID!]!) {
		cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
			cart {
				...CartFragment
			}
			userErrors {
				...CartUserErrorFragment
			}
		}
	}

	${cartFragment}
	${cartUserErrorFragment}
`;

export const cartLinesUpdate = `
	mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
		cartLinesUpdate(cartId: $cartId, lines: $lines) {
			cart {
				...CartFragment
			}
			userErrors {
				...CartUserErrorFragment
			}
		}
	}

	${cartFragment}
	${cartUserErrorFragment}
`;

export const getProductAvailabilityById = `
	query getProductById($id: ID!) {
		product(id: $id) {
			...ProductAvailabilityFragment
		}
	}

	${productAvailabilityFragment}
`;

export const collectionByHandleWithLimit = `
	query collectionByHandleWithLimit($handle: String!, $first: Int!) {
		collection: collectionByHandle(handle: $handle) {
			title
			products(first: $first) {
				edges {
					product: node {
						...ProductBasicFragment
					}
				}
			}
		}
	}

	${ productBasicFragment }
`;
